import UserRoleSelectOption from '@cobliteam/account/src/UserSettings/components/UserRoleSelectOption/UserRoleSelectOption';
import { UserRole } from '@cobliteam/common-types';
import Select, { SelectContent, SelectTrigger, SelectValue } from '@cobliteam/ui/form/Select';

/** Roles offered on the invite modal — every real role except the internal COBLER. */
const INVITE_ROLES: UserRole[] = [UserRole.ADMINISTRATOR, UserRole.MANAGER, UserRole.OPERATION, UserRole.MAP_VIEW, UserRole.USER_INSTALLER, UserRole.SAFETY_COACHER];

interface UserRoleSelectFieldProps {
  value: UserRole;
  onChange: (role: UserRole) => void;
  placeholder?: string;
}

/**
 * Slim role picker for the invite rows. Reuses the account module's `UserRoleSelectOption` (icon +
 * display name + admin-only gating) inside a plain Select — the full `UserRoleSelect` embeds its own
 * label and fixed width, which don't fit the modal's row layout.
 */
const UserRoleSelectField = ({ value, onChange, placeholder }: UserRoleSelectFieldProps) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent portal={false}>
      {INVITE_ROLES.map((role) => (
        <UserRoleSelectOption key={role} role={role} />
      ))}
    </SelectContent>
  </Select>
);

export default UserRoleSelectField;
